import axios from 'axios';

const url = `${process.env.REACT_APP_MEDIA_SERVICE}/image`;
// 0.0.0.0:8081/image/mexico

const uploaderApi = {
  getImages: (tag) => new Promise((resolve, reject) => {
    axios.get(`${url}/${tag}`, {
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),
  /**
   *
   * @param data
   * @param token
   * @param onProgress
   * @returns {Promise<>}
   */
  postImage: (data, token, onProgress) => axios.post(url, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'x-access-token': token,
    },
    onUploadProgress: () => {
      onProgress();
    },
  }),
  /**
   * @param data
   * @param token
   * @returns {Promise<>}
   */
  deleteImage: (data, token) => axios.delete(url, {
    data,
    headers: {
      'x-access-token': token,
    },
  }),
};

export default uploaderApi;
